import { Navigate } from 'react-router-dom';

import { BackLink } from '../components/BackLink.js';
import { Layout } from '../components/Layout.js';
import { Spinner } from '../components/Spinner.js';
import { useAuth } from '../features/auth/AuthContext.js';
import { useI18n } from '../i18n/index.js';
import { AnalyticsPanel } from './AnalyticsPanel.js';
import styles from './pageStyles.module.css';

/**
 * 분석 상세 — 누가 내 프로필을 봤나.
 *
 * 프로필에서는 **숫자 한 줄**만 보이고, 누르면 여기로 온다. 탭으로 두지
 * 않는 이유는 내 프로필과 남의 프로필의 뼈대를 같게 두기 위해서다.
 */
export function AnalyticsPage() {
  const { t } = useI18n();
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <Layout>
        <div className={styles.centered}>
          <Spinner label={t('common.loading')} />
        </div>
      </Layout>
    );
  }
  if (status !== 'authenticated') {
    return <Navigate to="/signin" replace />;
  }

  return (
    <Layout>
      <div className={styles.head}>
        <BackLink />
        <h1 className={styles.title}>{t('viewers.pageTitle')}</h1>
      </div>
      <AnalyticsPanel />
    </Layout>
  );
}
